/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-16 03:08 pm
 * Last Modified: Tuesday, 25-05-20 05:44 pm, by Ben Zhao
 */
import { useRouter } from 'next/router';
import { i18n } from 'next-i18next';
import type { ParsedUrlQuery } from 'node:querystring';
import type { SxProps, Theme } from '@mui/material';
import { Breadcrumbs } from '@ucard/ds/Breadcrumbs';
export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: (_label: string) => void;
}
const generateItems = (currentPath: string, query: ParsedUrlQuery): BreadcrumbItem[] => {
  let path = currentPath;
  let queryStr = '';
  if (currentPath.startsWith('/')) {
    path = currentPath.substring(1);
  }
  if (Object.keys(query).length) {
    const qArr = [];
    for (const key of Object.keys(query)) {
      qArr.push(`${key}=${query[key]?.toString()}`);
    }
    queryStr = `?${qArr.join('&')}`;
  }
  const pathSegments = path.split('/');
  const ns = pathSegments[0];
  return pathSegments.map((item, index) => ({
    label: i18n?.t(`breadcrumbs.${item}`, {
      ns
    }) || item,
    href: `/${pathSegments.slice(0, index + 1).join('/')}${index === pathSegments.length - 2 && index > 0 ? queryStr : ''}`
  }));
};
function XBreadcrumbs({
  sx
}: {
  sx?: SxProps<Theme>;
}) {
  const router = useRouter();
  const currentPath = router.pathname;
  const items = generateItems(currentPath, router.query);
  return <Breadcrumbs items={items} sx={{
    padding: '12px 20px',
    zIndex: 1,
    ...sx
  }} data-sentry-element="Breadcrumbs" data-sentry-component="XBreadcrumbs" data-sentry-source-file="index.tsx" />;
}
export default XBreadcrumbs;